export const REVIEW_BODY =
  "I needed specialized automotive parts that weren't available locally, and Quote N Buy handled everything for me. The quote came back quickly, pricing was transparent, and they kept me updated throughout the entire process.";

export const REVIEW_NAMES = [
  { name: 'Vanessa Reed', role: 'Operations Manager, USA' },
  { name: 'Nina Lee', role: 'Procurement, China' },
  { name: 'Santiago Martinez', role: 'Buyer, Chile' },
  { name: 'James Chen', role: 'Fleet Lead, Canada' },
  { name: 'Priya Sharma', role: 'Supply Chain, India' },
  { name: 'Olivia Brown', role: 'UK' },
  { name: 'Marcus Weber', role: 'Germany' },
  { name: 'Elena Rossi', role: 'Italy' },
  { name: 'Tomoko Sato', role: 'Japan' },
  { name: 'Ahmed Hassan', role: 'UAE' },
  { name: 'Sophie Martin', role: 'France' },
  { name: 'Daniel Okafor', role: 'Nigeria' },
  { name: 'Emma Wilson', role: 'Australia' },
  { name: 'Lucas Silva', role: 'Brazil' },
  { name: 'Anna Kowalski', role: 'Poland' },
  { name: 'Ryan Murphy', role: 'Ireland' },
  { name: 'Yuki Tanaka', role: 'Japan' },
  { name: 'Fatima Al-Farsi', role: 'Oman' },
  { name: 'Noah Taylor', role: 'New Zealand' },
  { name: 'Isabella Gomez', role: 'Mexico' },
  { name: 'Henry Clark', role: 'USA' },
  { name: 'Mia Andersson', role: 'Sweden' },
  { name: 'Ethan Park', role: 'South Korea' },
  { name: 'Chloe Dubois', role: 'Belgium' },
  { name: 'William Ng', role: 'Singapore' },
  { name: 'Ava Johansson', role: 'Norway' },
  { name: 'Benjamin Lee', role: 'Malaysia' },
  { name: 'Grace O’Brien', role: 'Ireland' },
];

export type StarDistributionRow = { star: number; count: number; percent: number };

/** Percent of reviews at each star level (1–5), for modal bar chart. */
export function computeStarDistribution(items: { stars: number }[]): StarDistributionRow[] {
  const counts: Record<number, number> = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  for (const item of items) {
    const s = Math.round(Number(item.stars));
    if (s >= 1 && s <= 5) counts[s] += 1;
  }
  const total = items.length;
  const denom = total > 0 ? total : 1;
  return [5, 4, 3, 2, 1].map((star) => ({
    star,
    count: counts[star],
    percent: Math.round((counts[star] / denom) * 100),
  }));
}

/** Mean star value (1–5) across all reviews. */
export function computeAverageRatingOutOfFive(items: { stars: number }[]): number {
  if (!items.length) return 0;
  let sum = 0;
  let n = 0;
  for (const item of items) {
    const s = Math.round(Number(item.stars));
    if (s >= 1 && s <= 5) {
      sum += s;
      n += 1;
    }
  }
  if (!n) return 0;
  return sum / n;
}

/** One decimal when needed, e.g. 4.23 → "4.2", 5.0 → "5" for display as `5 out of 5`. */
export function formatRatingOutOfFive(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0';
  const rounded = Math.round(value * 10) / 10;
  return String(parseFloat(rounded.toFixed(1)));
}

/** Replace leading count in localized string, e.g. "28 reviews" → "12 reviews". */
export function formatModalReviewCount(count: number, localizedExample: string | undefined) {
  if (!localizedExample) return `${count} reviews`;
  return localizedExample.replace(/\d+/, String(count));
}

export const ALL_REVIEWS = REVIEW_NAMES.map((n, i) => ({
  ...n,
  id: i + 1,
  stars: (i % 7 === 0 ? 4 : 5) as 4 | 5,
  daysAgo: (i % 9) + 1,
  text: REVIEW_BODY,
}));

export function reviewInitials(name: string) {
  return name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
